module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Light.99f49a0c.eot";